import React from "react";
import "./DotsColumn.css";
import { ReactComponent as Icon } from "../../../../../assets/homepage/icons/dotsColumn.svg";

function DottedAngle({ height = "91%", className, isVisible }) {
  return <Icon height={height} className={`${className} ${isVisible ? "dotsColumn-visible" : ""}`} />;
}

export default DottedAngle;
